"use client";

import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useState, useActionState } from "react";
import { toast } from "sonner";

import { Form } from "@/components/form";
import { SubmitButton } from "@/components/submit-button";

import { register, RegisterActionState } from "../actions";

export default function Register() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [state, formAction] = useActionState<RegisterActionState, FormData>(
    register,
    {
      status: "idle",
    },
  );

  useEffect(() => {
    if (state.status === "user_exists") {
      toast.error("Account already exists");
    } else if (state.status === "failed") {
      toast.error("Failed to create account");
    } else if (state.status === "invalid_data") {
      toast.error("Failed validating your submission!");
    } else if (state.status === "success") {
      toast.success("Account created successfully");
      router.refresh();
    }
  }, [state, router]);

  const handleSubmit = (formData: FormData) => {
    setEmail(formData.get("email") as string);
    formAction(formData);
  };

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-gray-50">
      <div className="z-10 w-full max-w-md overflow-hidden rounded-2xl border border-gray-100 shadow-xl">
        <div className="flex flex-col items-center justify-center space-y-3 border-b border-gray-200 bg-white px-4 py-6 pt-8 text-center sm:px-16">
          <Image
            src="/img/drtimmerluibrand.png"
            alt="DGP Plattform Logo"
            className="h-12 invert object-contain mb-4"
            width={258}
            height={48}
            priority={true}
          />
          <h3 className="text-xl font-semibold">Registrieren</h3>
          <p className="text-sm text-gray-500">Erstellen sie einen Account.</p>
        </div>
        <Form action={handleSubmit}>
          <SubmitButton>Registrieren</SubmitButton>
          <p className="text-center text-sm text-gray-600">
            {"Haben sie bereits einen account? "}
            <Link href="/login" className="font-semibold text-gray-800">
              hier
            </Link>
            {" anmelden."}
          </p>
        </Form>
      </div>
    </div>
  );
}
